import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ProductModel {
  id: string;
  name: string;
  brand: string;
  image: string;
  price: number;
  originalPrice: number;
  discountPercentage: number;
}
export const TopSellingModels = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };
  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };
  const products: ProductModel[] = [{
    id: 'iphone-15-pro',
    name: 'iPhone 15 Pro',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a1zZe5YfTvqp2TmKQmQWqk/image.png',
    price: 479,
    originalPrice: 729,
    discountPercentage: 34
  }, {
    id: 'iphone-13-pro',
    name: 'iPhone 13 Pro',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/j1haWtLZkePnbgPEWS6oLi/image.png',
    price: 264,
    originalPrice: 509,
    discountPercentage: 48
  }, {
    id: 'galaxy-s21',
    name: 'Galaxy S21',
    brand: 'Samsung',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xcWkHhZn7peZ2jG4h2eosT/image.png',
    price: 479,
    originalPrice: 729,
    discountPercentage: 34
  }, {
    id: 'iphone-15-pro-max',
    name: 'iPhone 15 Pro Max',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a1zZe5YfTvqp2TmKQmQWqk/image.png',
    price: 479,
    originalPrice: 729,
    discountPercentage: 34
  }, {
    id: 'iphone-15-pro-2',
    name: 'iPhone 15 Pro',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a1zZe5YfTvqp2TmKQmQWqk/image.png',
    price: 479,
    originalPrice: 729,
    discountPercentage: 34
  }, {
    id: 'iphone-15-pro-3',
    name: 'iPhone 15 Pro',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a1zZe5YfTvqp2TmKQmQWqk/image.png',
    price: 479,
    originalPrice: 729,
    discountPercentage: 34
  }];
  return <section className="py-12 bg-gray-50" data-id="element-1317">
      <div className="container mx-auto px-4" data-id="element-1318">
        <div className="flex justify-between items-center mb-6" data-id="element-1319">
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-1320">
            Top Selling Models
          </h2>
          <Link to="/products" className="text-blue-600 hover:underline font-medium" data-id="element-1321">
            View all
          </Link>
        </div>
        <div className="relative" data-id="element-1322">
          <button onClick={scrollLeft} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 z-10 bg-white rounded-full shadow-md p-2 hover:bg-gray-100" aria-label="Scroll left" data-id="element-1323">
            <ChevronLeftIcon className="h-6 w-6 text-gray-600" data-id="element-1324" />
          </button>
          <div ref={carouselRef} className="flex overflow-x-auto pb-6 hide-scrollbar gap-6" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-1325">
            <div className="min-w-[280px] bg-blue-100 rounded-lg overflow-hidden" data-id="element-1326">
              <div className="p-6 h-full flex flex-col justify-between" data-id="element-1327">
                <div data-id="element-1328">
                  <h3 className="text-xl font-bold text-blue-800 mb-2" data-id="element-1329">
                    Trade in to pay less
                  </h3>
                  <p className="text-blue-700 mb-8" data-id="element-1330">
                    Today's purchase could set you back a lot less when you
                    trade in an old device at the same time.
                  </p>
                </div>
                <button className="bg-white border border-blue-500 text-blue-600 px-4 py-2 rounded-md hover:bg-blue-50 transition-colors w-full" data-id="element-1331">
                  Get an offer now
                </button>
              </div>
            </div>
            {products.map(product => <div key={product.id} className="min-w-[280px] bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-1332">
                <Link to={`/product/${product.id}`} data-id="element-1333">
                  <div className="p-6" data-id="element-1334">
                    <div className="h-48 flex items-center justify-center mb-4" data-id="element-1335">
                      <img src={product.image} alt={product.name} className="h-full object-contain" data-id="element-1336" />
                    </div>
                    <div className="flex justify-between items-start" data-id="element-1337">
                      <div data-id="element-1338">
                        <h3 className="text-lg font-medium text-gray-800" data-id="element-1339">
                          {product.name}
                        </h3>
                        <div className="mt-1 flex items-baseline" data-id="element-1340">
                          <span className="text-sm text-gray-500" data-id="element-1341">fr </span>
                          <span className="text-lg font-bold ml-1" data-id="element-1342">
                            ${product.price.toFixed(2)}
                          </span>
                        </div>
                      </div>
                      <div className="bg-green-100 text-green-700 text-xs font-medium px-2 py-1 rounded" data-id="element-1343">
                        Save {product.discountPercentage}%
                      </div>
                    </div>
                    <div className="mt-2 text-sm text-gray-500" data-id="element-1344">
                      {product.brand}
                    </div>
                  </div>
                </Link>
              </div>)}
          </div>
          <button onClick={scrollRight} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 z-10 bg-white rounded-full shadow-md p-2 hover:bg-gray-100" aria-label="Scroll right" data-id="element-1345">
            <ChevronRightIcon className="h-6 w-6 text-gray-600" data-id="element-1346" />
          </button>
        </div>
      </div>
      <style jsx data-id="element-1347">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>;
};